// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"0d291763","322":"344d2adc","344":"611d6ebc","632":"3eb313fd"}[chunkId] + ".chunk.css";
};